import Component from '../colorz/Component';
import getData from '@utils/html/getData';

export default class Filters extends Component {
	onInit(el) {
		this.el = el;
		this.btnOpen = this.el.querySelectorAll('.js-open-filters');
		this.btnClose = this.el.querySelectorAll('.js-close-filters');
		this.filtersWrapper = this.el.querySelector('.js-tabs-filters-sorting');
	}

	onReady() {
		if (this.btnOpen) {
			this.openFilters();

			this.btnClose.forEach((btn) => {
				btn.addEventListener('click', () => {
					this.closeFilters();
				});
			});
		}
	}

	openFilters() {
		this.btnOpen.forEach((btn) => {
			btn.addEventListener('click', () => {
				this.tab = getData(btn, 'tab');

				document.body.addEventListener('keydown', (e) => {
					if (e.key == 'Escape') {
						this.closeFilters();
						document.querySelector('#open-filters-mobile').focus();
					}
				});

				if (btn.classList.contains('active')) {
					this.closeFilters();
				} else {
					if (this.el.querySelector('.js-open-filters.active')) {
						this.el
							.querySelector('.js-open-filters.active')
							.setAttribute('aria-expanded', 'false');
						this.el
							.querySelector('.js-open-filters.active')
							.classList.remove('active');
					}

					btn.classList.add('active');
					this.filtersWrapper.classList.add('active');
					this.filtersWrapper.setAttribute('data-tab-active', this.tab);
					btn.setAttribute('aria-expanded', 'true');

					if (this.tab == 'filters') {
						var containerToTrapFocusOn = document.querySelector(
							'#filters-tab-mobile',
						);
						var focusElement = document.querySelector('#filters-tab-mobile');
						document
							.querySelector('#open-sorting-mobile')
							.setAttribute('tabindex', '-1');
					} else if (this.tab == 'sorting') {
						var containerToTrapFocusOn = document.querySelector(
							'#sorting-tab-mobile',
						);
						var focusElement = document.querySelector('#sorting-tab-mobile');
						document
							.querySelector('#open-sorting-mobile')
							.removeAttribute('tabindex');
					}

					trapFocus(containerToTrapFocusOn, focusElement);
				}
			});
		});
	}

	closeFilters() {
		this.filtersWrapper.classList.remove('active');
		this.filtersWrapper.removeAttribute('data-tab-active');
		this.btnOpen.forEach((btn) => {
			btn.classList.remove('active');
			btn.setAttribute('aria-expanded', 'false');
		});
		removeTrapFocus();
		document.querySelector('#open-sorting-mobile').removeAttribute('tabindex');
	}
}
